import React from "react";

export function isUnder18(dobStr) {
    if (!dobStr) return false;
    const dob = new Date(dobStr + "T00:00:00Z");
    if (isNaN(dob)) return false;
    const today = new Date();
    let age = today.getUTCFullYear() - dob.getUTCFullYear();
    const m = today.getUTCMonth() - dob.getUTCMonth();
    if (m < 0 || (m === 0 && today.getUTCDate() < dob.getUTCDate())) age -= 1;
    return age < 18;
}

export const UNDERAGE_MESSAGE = "Ever After is available to adults 18 and older.";

export default function SignupConsent({ dob, setDob, agreed, setAgreed, idPrefix = "signup" }) {
    const maxDate = new Date().toISOString().slice(0, 10);
    return (
        <div className="space-y-4">
            <label className="block">
                <div className="text-[10px] tracking-[0.32em] uppercase text-ink-muted mb-1.5">Date of birth</div>
                <input
                    data-testid={`${idPrefix}-dob-input`}
                    type="date"
                    required
                    max={maxDate}
                    value={dob}
                    onChange={e => setDob(e.target.value)}
                    className="w-full bg-cream-soft border border-burgundy/20 focus:border-burgundy py-2.5 px-3 text-base text-ink focus:outline-none"
                />
            </label>
            {dob && isUnder18(dob) && (
                <div data-testid={`${idPrefix}-underage-error`} className="text-sm text-burgundy bg-rose/20 border border-burgundy/20 px-3 py-2">
                    {UNDERAGE_MESSAGE}
                </div>
            )}
            <label className="flex items-start gap-2 cursor-pointer" data-testid={`${idPrefix}-consent-row`}>
                <input
                    data-testid={`${idPrefix}-consent-checkbox`}
                    type="checkbox"
                    checked={agreed}
                    onChange={e => setAgreed(e.target.checked)}
                    className="mt-0.5 w-5 h-5 shrink-0 accent-burgundy"
                />
                <span className="text-sm text-ink leading-snug">
                    I am 18 or older and I agree to the{" "}
                    <a href="/terms" target="_blank" rel="noopener noreferrer" data-testid={`${idPrefix}-terms-link`} className="text-burgundy underline underline-offset-4">
                        Terms of Service
                    </a>{" "}
                    and{" "}
                    <a href="/privacy" target="_blank" rel="noopener noreferrer" data-testid={`${idPrefix}-privacy-link`} className="text-burgundy underline underline-offset-4">
                        Privacy Policy
                    </a>
                </span>
            </label>
        </div>
    );
}
